<template>
    <v-app id="SalesCalculator">

        <div id="header" class="row">
            <div class="brand col-6">
                <div :class="'logo' + (currentStep==nextLinks.length || !authorized ? ' reverse' : '')"><a href="/">Tebra</a></div>
            </div>
            <div class="col-6">
                <transition name="fade" :duration="{ enter: 200, leave: 200 }">
             <div class="steps-progress-bar" v-if="currentStep > 2 && currentStep!=nextLinks.length">
                <ul class="steps">
                    <li v-for="n in totalPanels" v-bind:key="n" class="steps-number" :class="activeStep(n)" @click="nextStep(n)">0{{ n }}</li>
                </ul>
                <div v-bind:class="'steps-progress steps-total-'+totalPanels+' steps-progress-'+currentStep"></div>
                <div :class="'steps-progress-bg steps-total-'+totalPanels"></div>
             </div>
                </transition>
            </div>

        <div class="advanced-settings" v-if="authorized">
            <a class="advanced-settings" data-toggle="modal" data-target="#advancedSettings">
                <img src="static/img/icon-advancedsettings.svg" />
            </a>
        </div>
        </div>

        <div class="mobile-message">
            <h2>Welcome to the Tebra Quote Builder. You can access it by logging in to your Tebra account from a desktop device.</h2>
        </div>

        <div class="panel row show-login" v-if="!authorized" :class="authorized ? '' : 'active'">
            <div class="panel-info col-12 col-md-6">
                <h1>Quote builder</h1>
            </div>
            <div class="panel-calc col-12 col-md-6">
                <div class="login-form">
                <p>Login with your Tebra account</p>
                <v-btn large color="primary" :href="proposalURL+'?login=1'">Enter</v-btn>
                </div>
            </div>
        </div>

        <div class="panel panel-step row" :class="activePanel(1)" data-id=1 data-title="Your practice">
            <div class="panel-info col-12 col-md-6">
                <h4 class="step-title">0{{currentStep}}</h4>

                <h2>Practice information</h2>
                <p>Our quotes are customized for each practice to fulfill their unique needs. Start by telling us a little bit about the practice.</p>

                <div v-if="(ehr.integrationType && integrations[ehr.integrationType]) && !(dentalPractice && (ehr.integrationType == 'notlisted' || ehr.integrationType == 'unsure'))">
                    <p class="medium ehr-text"><strong>Your integration type is: {{ integrations[ehr.integrationType].name }}</strong><br/>
                        {{ integrations[ehr.integrationType].description }}</p>

                    <p class="medium ehr-savings">
                        EHR integration: <span class="ehr-fee">$125</span>
                        <span class="ehr-fee-zero">$0</span> <span class="ehr-fee-limited">Limited time!</span>
                    </p>
                </div>

            </div>
            <div class="panel-calc col-12 col-md-6">
                <div class="row">
                    <div class="col-12">
                        <vuetify-google-autocomplete
                                ref="practicename"
                                id="practicename"
                                class="companyAutocomplete"
                                placeholder="Type your practice name"
                                label="Practice name"
                                v-on:placechanged="getAddressData"
                                v-on:no-results-found="setPracticeInput"
                                types="establishment"
                                enable-geolocation
                                country="us"
                                outlined
                                hide-details
                                :value="practice"
                        >
                        </vuetify-google-autocomplete>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <v-autocomplete
                                id="specialty" name="specialty" label="Specialty"
                                :items="specialties" :filter="customFilter"
                                item-text="display" class="specialty"
                                outlined hide-details
                                attach=".specialties"
                                v-model="specialty"
                        ></v-autocomplete>
                        <div class="specialties"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <NumberField name="providers" label="Number of providers" :max=30 v-model="providers" key="providers"></NumberField>
                    </div>
                    <div class="col-6">
                        <NumberField name="locations" label="Number of locations" :max=100 v-model="locations" key="locations"></NumberField>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <NumberField name="midlevels" label="Number of midlevels" :max=100 v-model="midlevels" key="midlevels"></NumberField>
                    </div>
                    <div class="col-6">
                        <v-autocomplete
                                id="ehr" name="ehr" label="EHR/PMS"
                                :items="ehrList"
                                item-text="name" class="ehr"
                                outlined hide-details
                                attach=".ehrList"
                                return-object v-model="ehr"
                        ></v-autocomplete>
                        <div class="ehrList"></div>
                    </div>
                </div>
            </div>

        </div>

        <div class="panel panel-step row" :class="activePanel(2)" data-id=2 data-title="Select your package">
        <div class="panel-calc col-12">
          <h4 class="step-title">0{{currentStep}}</h4>

          <h2>Select your package</h2>

          <div class="packages container">
          <div class="row no-gutters">
            <div class="col-4">
              <div class="package" :class="{ 'selected' : selectedPackage.value == 'good'}">
                <div class="package-details">
              <h3 class="package-name">Core</h3>
              <span class="package-price">{{ totalPackageGoodMonthly | toCurrency }}</span>
              <ul>
                <li v-if="this.dentalPractice"><img src="static/img/miniicon-digital-registration.svg" /><span>Digital registration, intake & forms</span></li>
                <li><img src="static/img/miniicon-payments.svg" /><span>Patient payments</span></li>
                <li><img src="static/img/miniicon-reputation.svg" /><span>Reputation management</span></li>
                <li><img src="static/img/miniicon-scheduling.svg" /><span>Scheduling</span></li>
                <li><img src="static/img/miniicon-text-messaging.svg" /><span>Text messaging</span></li>
                <li><img src="static/img/miniicon-website.svg" /><span>Website and SEO</span></li>
              </ul>
                </div>
                <button @click="selectPackage(0)" class="btn btn-large btn-light">{{ selectedPackage.value == 'good' ? 'Selected' : 'Select this package' }}</button>
              </div>
            </div>
            <div class="col-4">
              <div class="package recommended" :class="{ 'selected' : selectedPackage.value == 'better'}">
                <div class="package-details">
              <h3 class="package-name package-name-better">Essential</h3>
              <span class="package-price">{{ totalPackageBetterMonthly | toCurrency }}</span>
              <ul>
                <li>Everything in Core</li>
                <li v-if="!this.dentalPractice"><img src="static/img/miniicon-digital-registration.svg" /><span>Digital registration, intake & forms</span></li>
                <li><img src="static/img/miniicon-blog.svg" /><span>Blog</span></li>
              </ul>
                </div>
                <button @click="selectPackage(1)" class="btn btn-large btn-light">{{ selectedPackage.value == 'better' ? 'Selected' : 'Select this package' }}</button>
              </div>
            </div>
            <div class="col-4">
              <div class="package" :class="{ 'selected' : selectedPackage.value == 'best'}">
                <div class="package-details">
                <h3 class="package-name">Premium</h3>
              <span class="package-price">{{ totalPackageBestMonthly | toCurrency }}</span>
              <ul>
                <li>Everything in Essential</li>
                <li><img src="static/img/miniicon-profiles.svg" /><span>Teleheath</span></li>
                <li><img src="static/img/miniicon-social.svg" /><span>Social media</span></li>
                <li><img src="static/img/miniicon-seo.svg" /><span>SEO starter</span></li>
              </ul>
                </div>
                <button @click="selectPackage(2)" class="btn btn-large btn-light">{{ selectedPackage.value == 'best' ? 'Selected' : 'Select this package' }}</button>
              </div>
            </div>
            <div class="col-12"><p class="text-center fine-print">Cost displayed is by month, excluding first month setup fee.</p></div>
          </div>
          </div>

        </div>

      </div>

        <div class="panel panel-step row" :class="activePanel(3)" data-id=3 data-title="Your solution">
            <div class="panel-info col-12 col-md-6">
                <h4 class="step-title">0{{currentStep}}</h4>

                <h2>Providers</h2>
                <div class="scrolly">
                <h3><img src="static/img/icon-practicegrowth.svg" /> Practice Growth</h3>
                <ul>
                    <li>Mobile-responsive website</li>
                    <li>Search engine optimization</li>
                    <li>Reputation management</li>
                    <li>Enhanced web presence with 65+ web profiles</li>
                    <li>Universal scheduling</li>
                    <li>Text communications (call-to-text, web-to-text and 2-way text)</li>
                    <li>Email campaigns</li>
                    <li>Practice Portal & Insights</li>
                </ul>
                </div>
            </div>

            <div class="panel-calc col-12 col-md-6">
                <div class="row">
                    <div class="col-12">
                        <Price :originalPrice="originalMonthlyFee" :updatedPrice="updatedMonthlyFee" unit="per month"
                               title="" feeType="monthly"
                        ></Price>
                        <EditPrice :originalPrice="originalMonthlyFee" name="monthlyFee" label="Monthly rate"
                                   @focus.native="$event.target.select()" v-model="updatedMonthlyFee"
                        ></EditPrice>
                    </div>
                    <div v-if="debug">
                        FINAL: <br/>
                        Updated Price: {{ updatedMonthlyFee }}<br/>
                    </div>

                </div>
            </div>

        </div>

        <div class="panel panel-step row" :class="activePanel(4)" data-id=4 data-title="Mid-levels" v-show="midlevels > 0">
            <div class="panel-info col-12 col-md-6">
                <h4 class="step-title">0{{currentStep}}</h4>

                <h2>Mid-levels</h2>

                <div class="scrolly">

                <h3><img src="static/img/icon-practicegrowth.svg" /> Practice Growth</h3>
                <ul>
                    <li>Reputation management</li>
                    <li>Online scheduling from practice website</li>
                    <li>Text communications (call-to-text, web-to-text and 2-way text)</li>
                    <li>Practice Portal & Insights</li>
                </ul>
                </div>
            </div>

            <div class="panel-calc col-12 col-md-6">
                <div class="row">
                    <div class="col-12">
                        <Price :originalPrice="originalMidlevelFee" :updatedPrice="updatedMidlevelFee" unit="per month"
                               title="" feeType="monthly"
                        ></Price>
                        <EditPrice :originalPrice="originalMidlevelFee" name="midlevelFee" label="Monthly rate"
                                   @focus.native="$event.target.select()" v-model="updatedMidlevelFee"
                        ></EditPrice>
                    </div>
                    <div v-if="debug">
                        FINAL: <br/>
                        Updated Price: {{ updatedMidlevelFee }}<br/>
                    </div>
                </div>
            </div>

        </div>

        <div class="panel panel-step row" :class="activePanel(5)" data-id=5 data-title="Software upgrades">
        <div class="panel-info col-12 col-md-6">
          <h4 class="step-title">0{{currentStep}}</h4>

          <h2>Software upgrades</h2>

          <v-tabs class="content-tabs" v-model="tabUpgrades" fixed-tabs slider-size="3" slider-color="transparent" background-color="transparent">
            <v-tab key="0">Plus</v-tab>
            <v-tab key="1">Pro</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabUpgrades">
            <v-tab-item key="0">
              <div class="scrolly">
                <h3><img src="static/img/icon-intake.svg" /> Digital registration, intake & forms</h3>
                <ul>
                  <li>Send new and returning patients customizable intake forms</li>
                  <li>Create unlimited custom forms for registration</li>
                  <li>Easily embed custom forms on your practice site</li>
                  <li>Capture consent</li>
                </ul>
              </div>
            </v-tab-item>
            <v-tab-item key="1">
              <div class="scrolly">
                <h3><img src="static/img/icon-intake.svg" /> Digital registration & intake</h3>
                <ul>
                  <li>Send new and returning patients customizable intake forms</li>
                  <li>Create unlimited custom forms for registration</li>
                  <li>Easily embed custom forms on your practice site</li>
                  <li>Capture consent</li>
                </ul>

                <h3><img src="static/img/icon-telehealth.svg" /> Telehealth</h3>
                <ul>
                  <li>Telehealth with 2-way HD video</li>
                  <li>Unique link for virtual visits that patients can join with 1-click</li>
                  <li>Patients can schedule telehealth visits</li>
                  <li>Receive telehealth notifications</li>
                </ul>
              </div>
            </v-tab-item>
          </v-tabs-items>

        </div>
        <div class="panel-calc col-12 col-md-6">
          <div class="row">
            <div class="col-12">
              <Price :originalPrice="originalUpgradesFee" :updatedPrice="updatedUpgradesFee" unit="per month"
                     title="" feeType="monthly"
              ></Price>
              <div v-if="debug">
                FINAL: <br/>
                Updated Price: {{ updatedUpgradesFee }}<br/>
              </div>
            </div>
            <div class="col-1">
              <v-switch v-model="toggleUpgrades" inset class="toggle"></v-switch>
            </div>
            <div class="col-8">
              <v-select v-model="selectedUpgrade"
                        :items="upgradesfees"
                        label="Software upgrade" outlined :disabled="!toggleUpgrades"
                        item-text="name" item-value="fees[practiceSize]" placeholder=""
                        return-object
              >
                <template v-slot:selection="{item}">
                  {{ item.name }}
                </template>
                <template v-slot:item="{item}">
                  <span class="option--name">{{ item.name }}</span> <span class="option--cost" v-if="item.fees[practiceSize]">{{ item.fees[practiceSize] | toCurrency }}/month</span>
                </template>
              </v-select>
            </div>
            <div class="col-3">
              <EditPrice :originalPrice="dentalPractice ? updatedUpgradesFee : originalUpgradesFee" name="upgrades" label="Monthly rate" :disabled="!selectedUpgrade"
                         @focus.native="$event.target.select()" v-model="updatedUpgradesFee"
              ></EditPrice>

            </div>
          </div>
        </div>
      </div>

        <div class="panel panel-step row" :class="activePanel(6)" data-id=6 data-title="First month setup">
            <div class="panel-info col-12 col-md-6">
                <h4 class="step-title">0{{currentStep}}</h4>

                <h2>First month setup</h2>
                <div class="scrolly">
                <h3><img src="static/img/icon-onboarding.svg" />Consultative discovery and onboarding</h3>
                <ul>
                    <li>Audit to identify any pre-existing factors</li>
                    <li>Research to determine the best services to highlight</li>
                    <li>Kickstart reputation campaigns</li>
                    <li>Website design + two rounds of reviews</li>
                    <li>8 service pages per provider (maximum of 24)*</li>
                    <li>Search optimized content + two rounds of reviews</li>
                    <li>Claim and optimize 65+ online profiles</li>
                    <li>Online booking enabled</li>
                    <li>Appointment reminders enabled</li>
                    <li>Call tracking</li>
                    <li>Integrate with your EHR or PMS</li>
                    <li>Quality audit</li>
                    <li>Domain transfer</li>
                    <li>Practice Portal tour</li>
                    <li>Text messaging configuration</li>
                    <li>Merchant services account setup</li>
                  <li v-if="selectedUpgrade">5 custom intake forms</li>
                  <li v-if="selectedUpgrade">Form-builder training</li>
                </ul>
                </div>

            </div>
            <div class="panel-calc col-12 col-md-6">
                <div class="row">
                <div class="col-12">
                <Price :originalPrice="originalFirstMonthSetup" :updatedPrice="totalFirstMonthSetup" unit="one time rate"
                       title="" feeType="once"
                ></Price>
                <EditPrice :originalPrice="firstMonthSetup" name="setupFee" label="First month"
                           @focus.native="$event.target.select()" v-model="updatedSetupFee"
                ></EditPrice>
                </div>

                <div class="col-6">
                    <NumberField name="additionalServicePages" label="Additional service pages"
                                 :max=100 hint="$150 per page"
                                 v-model="additionalServicePages" key="servicePages"
                    ></NumberField>
                </div>
                <div class="col-6">
                    <EditPrice :originalPrice="originalServicePagesFee" name="additionalServicePagesFee" label=""
                               @focus.native="$event.target.select()" v-model="updatedServicePagesFee"
                    ></EditPrice>
                </div>

                  <div class="col-6">
                    <NumberField name="additionalCustomForms" label="Additional custom forms"
                                 :max=100 hint="$250 per five forms" :increment=5
                                 v-model="additionalCustomForms" key="customForms"
                    ></NumberField>
                  </div>
                  <div class="col-6">
                    <EditPrice :originalPrice="originalCustomFormsFee" name="additionalCustomFormsFee" label=""
                               @focus.native="$event.target.select()" v-model="updatedCustomFormsFee"
                    ></EditPrice>
                  </div>
                </div>
            </div>
        </div>

        <div class="panel panel-step row" :class="activePanel(7)" data-id=7 data-title="Additional locations" v-show="locations>1">
            <div class="panel-info col-12 col-md-6">
                <h4 class="step-title">0{{currentStep}}</h4>

                <h2>Additional Locations</h2>

                <h3><img src="static/img/icon-locations.svg" /> Locations</h3>
                <ul>
                    <li>Call tracking for each location</li>
                    <li>Web profiles optimized for each location</li>
                    <li>Search engine optimization (SEO) for each location</li>
                    <li>Online scheduling available for each location</li>
                </ul>

            </div>
            <div class="panel-calc col-12 col-md-6">
                <div class="row">
                    <div class="col-12">
                        <Price :originalPrice="originalLocationsFee" :updatedPrice="updatedLocationsFee" unit="per month"
                               title="" feeType="monthly"
                        ></Price>
                        <EditPrice :originalPrice="originalLocationsFee" name="additionalLocationsFee" label="Locations"
                                   @focus.native="$event.target.select()" v-model="updatedLocationsFee"
                        ></EditPrice>

                        <div v-if="debug">
                        FINAL: <br/>
                        Updated Price: {{ updatedLocationsFee }}<br/>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="panel panel-step row" :class="activePanel(8)" data-id=8 data-title="Growth services">
            <div class="panel-info col-12 col-md-6">
                <h4 class="step-title">0{{currentStep}}</h4>

                <h2>Growth services</h2>

                <v-tabs class="content-tabs" v-model="tabGrowthServices" fixed-tabs slider-size="3" slider-color="transparent" background-color="transparent">
                    <v-tab key="0">Search Advertising</v-tab>
                    <v-tab key="1">Premium Offsite SEO</v-tab>
                    <v-tab key="2">Blog & Social</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabGrowthServices" class="outerTab">
                    <v-tab-item key="0">

                        <div class="row">
                            <div class="col-8">

                                <div class="vertical-tabs-wrapper">
                                    <div class="vertical-tab" v-show="activeSearchAdvertisingTab==0">
                                        <h3><img src="static/img/icon-searchadvertising.svg"/> Intro</h3>
                                        <ul>
                                            <li>50-50 estimated clicks/mo</li>
                                            <li>1 branded campaign</li>
                                            <li>1 specialty campaign</li>
                                            <li>Service campaigns not included</li>
                                            <li>Up to 1 location</li>
                                        </ul>
                                    </div>
                                    <div class="vertical-tab" v-show="activeSearchAdvertisingTab==1">
                                        <h3><img src="static/img/icon-searchadvertising.svg"/> Starter</h3>
                                        <ul>
                                            <li>90 - 250 estimated clicks/mo</li>
                                            <li>1 branded campaign</li>
                                            <li>1 specialty campaign</li>
                                            <li>3 service campaigns</li>
                                            <li>Up to 1 location</li>
                                        </ul>
                                    </div>
                                    <div class="vertical-tab" v-show="activeSearchAdvertisingTab==2">
                                        <h3><img src="static/img/icon-searchadvertising.svg"/> Plus</h3>
                                        <ul>
                                            <li>110 - 375 estimated clicks/mo</li>
                                            <li>1 branded campaign</li>
                                            <li>1 specialty campaign</li>
                                            <li>4 service campaigns</li>
                                            <li>Up to 2 locations</li>
                                        </ul>
                                    </div>
                                    <div class="vertical-tab" v-show="activeSearchAdvertisingTab==3">
                                        <h3><img src="static/img/icon-searchadvertising.svg"/> Advanced</h3>
                                        <ul>
                                            <li>150 - 500 estimated clicks/mo</li>
                                            <li>1 branded campaign</li>
                                            <li>1 specialty campaign</li>
                                            <li>6 service campaigns</li>
                                            <li>Up to 3 locations</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                            <div class="col-4">
                                <ul class="vertical-tabs-selector">
                                    <li :class="'tab-selector ' + (activeSearchAdvertisingTab==0 ? 'active' : '')"
                                        @click="activeSearchAdvertisingTab=0">Intro
                                    </li>
                                    <li :class="'tab-selector ' + (activeSearchAdvertisingTab==1 ? 'active' : '')"
                                        @click="activeSearchAdvertisingTab=1">Starter
                                    </li>
                                    <li :class="'tab-selector ' + (activeSearchAdvertisingTab==2 ? 'active' : '')"
                                        @click="activeSearchAdvertisingTab=2">Plus
                                    </li>
                                    <li :class="'tab-selector ' + (activeSearchAdvertisingTab==3 ? 'active' : '')"
                                        @click="activeSearchAdvertisingTab=3">Advanced
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </v-tab-item>
                    <v-tab-item key="1">

                        <div class="row">
                            <div class="col-8">

                                <div class="vertical-tabs-wrapper">
                                    <div class="vertical-tab" v-show="activePremiumSEOTab==0">
                                        <h3><img src="static/img/icon-premiumseo.svg"/> Starter</h3>
                                        <ul>
                                            <li>2 - 3 new backlinks per month</li>
                                            <li>Monthly email report</li>
                                            <li>Optimized for keywords</li>
                                            <li>High authority publishers</li>
                                            <li>Backlinks are monitored</li>
                                        </ul>
                                    </div>

                                    <div class="vertical-tab" v-show="activePremiumSEOTab==1">
                                        <h3><img src="static/img/icon-premiumseo.svg"/> Plus</h3>
                                        <ul>
                                            <li>5 - 6 new backlinks per month</li>
                                            <li>Monthly email report</li>
                                            <li>Optimized for keywords</li>
                                            <li>High authority publishers</li>
                                            <li>Backlinks are monitored</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                            <div class="col-4">
                                <ul class="vertical-tabs-selector">
                                    <li :class="'tab-selector ' + (activePremiumSEOTab==0 ? 'active' : '')"
                                        @click="activePremiumSEOTab=0">Starter
                                    </li>
                                    <li :class="'tab-selector ' + (activePremiumSEOTab==1 ? 'active' : '')"
                                        @click="activePremiumSEOTab=1">Plus
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </v-tab-item>
                    <v-tab-item key="2">

                        <div class="row">
                            <div class="col-8">

                                <div class="vertical-tabs-wrapper">
                                    <div class="vertical-tab" v-show="activeBlogSocialTab==0">
                                        <h3><img src="static/img/icon-blog.svg"/> Blog</h3>
                                        <ul>
                                            <li>1 blog per month</li>
                                            <li>400 - 600 words</li>
                                            <li>Curated image</li>
                                            <li>Links to service pages</li>
                                            <li>Branded specialty & service terms</li>
                                        </ul>
                                    </div>
                                    <div class="vertical-tab" v-show="activeBlogSocialTab==1">

                                        <h3><img src="static/img/icon-socialmedia.svg"/> Social media</h3>
                                        <ul>
                                            <li>3 posts to Facebook</li>
                                            <li>Online booking on Facebook</li>
                                            <li>Sponsored posts on Facebook & Instagram</li>
                                            <li>Weekly email report</li>
                                            <li>Manage social media from one place</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <ul class="vertical-tabs-selector">
                                    <li :class="'tab-selector ' + (activeBlogSocialTab==0 ? 'active' : '')"
                                        @click="activeBlogSocialTab=0">Blog
                                    </li>
                                    <li :class="'tab-selector ' + (activeBlogSocialTab==1 ? 'active' : '')"
                                        @click="activeBlogSocialTab=1">Social
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </v-tab-item>
                </v-tabs-items>

            </div>
            <div class="panel-calc col-12 col-md-6 growth-services">
                <div class="row">
                    <div class="col-12">
                        <Price :originalPrice="originalGrowthServices" :updatedPrice="updatedGrowthServices" unit="per month"
                               title="" feeType="monthly"></Price>
                    </div>

                    <div class="col-1">
                        <v-switch v-model="toggleSearchAdvertising" inset class="toggle"></v-switch>
                    </div>
                    <div class="col-8">
                        <v-select v-model="selectedSearchAdvertising"
                                  :items="searchAdvertisingItems"
                                  label="Search Advertising plan" outlined :disabled="!toggleSearchAdvertising"
                                  item-text="name" item-value="fee" placeholder=""
                                  return-object
                        >
                            <template v-slot:selection="{item}">
                                {{ item.fullname }}
                            </template>
                            <template v-slot:item="{item}">
                                <span class="option--name">{{ item.name }}</span> <span class="option--cost" v-if="item.fee">{{ item.fee | toCurrency }}/month</span>
                            </template>
                        </v-select>
                    </div>
                    <div class="col-3">
                        <EditPrice :originalPrice="originalSearchAdvertising" name="searchAdvertising" label="Monthly rate" :disabled="!selectedSearchAdvertising"
                                   @focus.native="$event.target.select()" v-model="updatedSearchAdvertising"
                        ></EditPrice>

                    </div>
                    <div class="col-1">
                        <v-switch v-model="togglePremiumSEO" inset class="toggle"></v-switch>
                    </div>
                    <div class="col-8">
                        <v-select v-model="selectedPremiumSEO"
                                  :items="premiumSEOItems"
                                  label="Premium Offsite SEO plan" outlined :disabled="!togglePremiumSEO"
                                  item-text="name" item-value="fee" placeholder=""
                                  return-object
                        >
                            <template v-slot:selection="{item}">
                                {{ item.fullname }}
                            </template>
                            <template v-slot:item="{item}">
                                <span class="option--name">{{ item.name }}</span> <span class="option--cost" v-if="item.fee">{{ item.fee | toCurrency }}/month</span>
                            </template>
                        </v-select>
                    </div>
                    <div class="col-3">
                        <EditPrice :originalPrice="originalPremiumSEO" name="premiumSEO" label="Monthly rate" :disabled="!selectedPremiumSEO"
                                   @focus.native="$event.target.select()" v-model="updatedPremiumSEO"
                        ></EditPrice>

                    </div>
                    <div class="col-1">
                    <v-switch v-model="toggleBlogSocial" inset class="toggle"></v-switch>
                    </div>
                    <div class="col-8">
                    <v-select v-model="selectedBlogSocial"
                              :items="blogSocialItems"
                              label="Blog & Social plan" outlined :disabled="!toggleBlogSocial"
                              item-text="name" item-value="fee" placeholder=""
                              return-object
                    >
                        <template v-slot:selection="{item}">
                            {{ item.fullname }}
                        </template>
                        <template v-slot:item="{item}">
                            <span class="option--name">{{ item.name }}</span> <span class="option--cost" v-if="item.fee">{{ item.fee | toCurrency }}/month</span>
                        </template>
                    </v-select>
                    </div>
                    <div class="col-3">
                        <EditPrice :originalPrice="originalBlogSocial" name="blogSocial" label="Monthly rate" :disabled="!selectedBlogSocial"
                                   @focus.native="$event.target.select()" v-model="updatedBlogSocial"
                        ></EditPrice>

                    </div>
                </div>
            </div>
        </div>

        <div class="panel panel-step row order-summary" :class="activePanel(9)" data-id=9 data-title="Order summary">
            <div class="panel-info col-12 col-md-6">
              <h4 class="step-title">&nbsp;</h4>
                <h2>Order summary</h2>

                <div class="scrolly">
                    <h3 v-if="updatedMonthlyFee">Software <span>12 month term</span></h3>
                    <table v-if="updatedMonthlyFee">
                        <tr v-if="updatedMonthlyFee">
                            <td>{{ solutionfees.fullname }}</td>
                            <td v-if="rate=='monthly'">{{ updatedMonthlyFee | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ updatedQuarterlyFee | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedAnnualProvider | toCurrency }} per year</td>
                        </tr>
                        <tr v-if="updatedMidlevelFee">
                            <td>{{ midlevelfees.fullname }}</td>
                            <td v-if="rate=='monthly'">{{ updatedMidlevelFee | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ updatedQuarterlyMidlevelFee | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedAnnualMidlevel | toCurrency }} per year</td>
                        </tr>
                        <tr v-if="updatedLocationsFee">
                            <td>Additional locations</td>
                            <td v-if="rate=='monthly'">{{ updatedLocationsFee | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ quarterlyLocationsFee | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedAnnualLocations | toCurrency }} per year</td>
                        </tr>
                        <tr v-if="selectedUpgrade">
                            <td>{{ selectedUpgrade.fullname }}</td>
                            <td v-if="rate=='monthly'">{{ updatedUpgradesFee | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ quarterlyUpgradesFee | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedAnnualUpgrades | toCurrency }} per year</td>
                        </tr>
                        <tr class="total-row" v-if="rate=='monthly' && totalSoftwareSavingsMonthlyPlan > 0">
                            <td>SOFTWARE SAVINGS</td>
                            <td>{{ totalSoftwareSavingsMonthlyPlan | toCurrency }} per year</td>
                        </tr>
                      <tr class="total-row" v-if="rate=='quarterly' && totalSoftwareSavingsQuarterlyPlan > 0">
                        <td>SOFTWARE SAVINGS</td>
                        <td>{{ totalSoftwareSavingsQuarterlyPlan | toCurrency }} per year</td>
                      </tr>
                        <tr class="total-row" v-if="rate=='annual' && totalSoftwareSavingsAnnualPlan > 0">
                            <td>SOFTWARE SAVINGS</td>
                            <td>{{ totalSoftwareSavingsAnnualPlan | toCurrency }} per year</td>
                        </tr>
                        <tr class="total-row" v-if="totalMonthlySoftware">
                            <td>TOTAL SOFTWARE</td>
                            <td v-if="rate=='monthly'">{{ totalMonthlySoftware | toCurrency }} per month<br/>{{ totalMonthlySoftware*12 | toCurrency }} per year</td>
                            <td v-if="rate=='quarterly'">{{ updatedQuarterlySoftware | toCurrency }} per quarter<br/>{{ updatedQuarterlySoftware*4 | toCurrency }} per year</td>
                            <td v-if="rate=='annual'">{{ updatedAnnualSoftware | toCurrency }} per year</td>
                        </tr>
                    </table>

                    <h3 v-if="updatedSearchAdvertising || updatedPremiumSEO || updatedBlogSocial">Services</h3>
                    <table>
                        <tr v-if="toggleSearchAdvertising">
                            <td>{{ selectedSearchAdvertising.fullname }}</td>
                            <td v-if="rate=='monthly'">{{ updatedSearchAdvertising | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ updatedSearchAdvertising * 3 | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedSearchAdvertising * 12 | toCurrency }} per year</td>
                        </tr>
                        <tr v-if="togglePremiumSEO">
                            <td>{{ selectedPremiumSEO.fullname }}</td>
                            <td v-if="rate=='monthly'">{{ updatedPremiumSEO | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ updatedPremiumSEO * 3 | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedPremiumSEO * 12 | toCurrency }} per year</td>
                        </tr>
                        <tr v-if="toggleBlogSocial">
                            <td>{{ selectedBlogSocial.fullname }}</td>
                            <td v-if="rate=='monthly'">{{ updatedBlogSocial | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ updatedBlogSocial * 3 | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedBlogSocial * 12 | toCurrency }} per year</td>
                        </tr>
                        <tr class="total-row" v-if="totalServicesSavings">
                            <td>SERVICES SAVINGS</td>
                            <td>{{ totalServicesSavings | toCurrency }} per year</td>
                        </tr>
                        <tr class="total-row" v-if="updatedGrowthServices">
                            <td>TOTAL SERVICES</td>
                            <td v-if="rate=='monthly'">{{ updatedGrowthServices | toCurrency }} per month</td>
                            <td v-if="rate=='quarterly'">{{ updatedGrowthServices * 3 | toCurrency }} per quarter</td>
                            <td v-if="rate=='annual'">{{ updatedGrowthServices * 12 | toCurrency }} per year</td>
                        </tr>
                    </table>

                    <br/>

                    <h3 v-if="updatedMonthlyFee">First month setup</h3>
                    <table v-if="updatedMonthlyFee">
                        <tr>
                            <td>Onboarding</td>
                            <td v-if="monthlyOrQuarterly">{{ updatedSetupFee | toCurrency }}</td>
                            <td v-if="rate == 'annual'">{{ annualFirstMonthSetup | toCurrency }}</td>
                        </tr>
                        <tr v-if="additionalServicePages">
                            <td>{{ additionalServicePages }} additional service page<span v-if="additionalServicePages > 1">s</span></td>
                            <td>{{ updatedServicePagesFee | toCurrency }}</td>
                        </tr>
                      <tr v-if="additionalCustomForms">
                        <td>{{ additionalCustomForms }} additional custom forms<span v-if="additionalCustomForms > 1">s</span></td>
                        <td>{{ updatedCustomFormsFee | toCurrency }}</td>
                      </tr>
                        <tr class="total-row" v-if="monthlyOrQuarterly && totalFirstMonthSavings">
                            <td>ONBOARDING SAVINGS</td>
                            <td v-if="monthlyOrQuarterly">{{ totalFirstMonthSavings| toCurrency }}</td>
                        </tr>
                        <tr class="total-row" v-if="rate=='annual' && annualFirstMonthSavings">
                            <td>ONBOARDING SAVINGS</td>
                            <td v-if="rate=='annual'">{{ annualFirstMonthSavings | toCurrency }}</td>
                        </tr>
                        <tr class="total-row">
                            <td>TOTAL ONBOARDING</td>
                            <td v-if="monthlyOrQuarterly">{{ totalFirstMonthSetup | toCurrency }}</td>
                            <td v-if="rate=='annual'">{{ annualFirstMonthSetup | toCurrency }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="panel-calc col-12 col-md-6">
                <div class="row">
                    <div class="col-12">

                        <v-radio-group v-model="rate" row class="rate-changer">
                            <v-radio label="Monthly" value="monthly" checked></v-radio>
                            <v-radio label="Quarterly" value="quarterly"></v-radio>
                            <v-radio label="Annually" value="annual"></v-radio>
                        </v-radio-group>

                        <div class="row" v-if="rate=='monthly'">
                            <div class="col-12">
                                <p>Total per month</p>
                                <Price :originalPrice="totalMonthlyOriginal" :updatedPrice="totalMonthly" unit=""
                                       title="" feeType="monthly"></Price>
                            </div>
                            <div class="col-12 annual-savings">
                                <div class="savings-text" v-if="totalMonthlySavings > 0">Savings per year: <span>{{ totalMonthlySavings | toCurrency }}</span></div>
                                <div class="savings-text" v-if="totalFirstMonthSavings > 0">Onboarding savings: <span>{{ totalFirstMonthSavings | toCurrency }}</span></div>
                            </div>
                        </div>

                        <div class="row quarterly-tab" v-if="rate=='quarterly'">
                            <div class="col-12 quarter-software">
                                <p>Total per quarter</p>
                                <Price :originalPrice="totalQuarterlyOriginal" :updatedPrice="totalQuarterly" unit=""
                                       title="" feeType="quarterly"></Price>
                            </div>
                            <div class="col-12 quarterly-savings">
                                <div class="savings-text" v-if="totalQuarterlySavings > 0">Savings per year: <span>{{ totalQuarterlySavings | toCurrency }}</span></div>
                                <div class="savings-text" v-if="quarterlyFirstMonthSavings > 0" >Onboarding savings: <span>{{ quarterlyFirstMonthSavings | toCurrency }}</span></div>
                            </div>
                        </div>

                        <div class="row annual-tab" v-if="rate=='annual'">
                            <div class="col-12 annual-software">
                                <p>Total per year</p>
                                <Price :originalPrice="updatedTotalAnnual" :updatedPrice="updatedTotalAnnual" unit=""
                                       title="" feeType="once" v-model="updatedTotalAnnual"></Price>
                                <a class="override-annual" data-toggle="modal" data-target="#overrideAnnual">
                                    <img src="static/img/icon-dots.svg" />
                                </a>
                            </div>
                            <div class="col-12 annual-savings">
                                <div class="savings-text" v-if="totalAnnualSavings > 0">Savings per year: <span>{{ totalAnnualSavings | toCurrency }}</span></div>
                                <div class="savings-text" v-if="annualFirstMonthSavings > 0" >Onboarding savings: <span>{{ annualFirstMonthSavings | toCurrency }}</span></div>
                            </div>
                        </div>

                    </div>

                    <div class="col-12">
                        <div class="refer-a-provider">Ask me how you can save an additional $500 with our Refer a Provider program!</div>
                    </div>
                </div>
            </div>
        </div>

        <div id="footer" class="row">
          <div v-if="currentStep==2" class="col-12 panel-next panel-spread">
            <a class="plain-link"
               @click="nextStep(currentStep-1)">Cancel</a>
            <a class="plain-link"
               @click="nextStep(currentStep+1)">Customize</a>
            <transition name="fade" :duration="{ enter: 500, leave: 300 }">
              <a v-if="currentStep === 2" class="plain-link primary-link"
                 @click="lastStep()"><span>Next</span></a>
            </transition>
          </div>
            <div v-if="currentStep!=2" class="col-6 panel-next">
                <div :class="'practice-name' + (currentStep==nextLinks.length ? ' reverse' : '')">
                    <p v-if="practice">Tebra customized quote for:
                        <strong>{{ practice }}</strong></p>
                </div>
            </div>
            <div v-if="currentStep!=2" class="col-2 panel-next">
                <a v-if="currentStep>2 && currentStep<nextLinks.length" class="prev-link"
                   @click="nextStep(currentStep-1)">Previous</a>
              <a v-if="currentStep==nextLinks.length" class="prev-link"
                 @click="nextStep(previousStep)">Previous</a>
            </div>
            <div v-if="currentStep!=2" class="col-4 panel-next">
                <transition name="fade" :duration="{ enter: 300, leave: 300 }">
                    <a v-if="currentStep===nextLinks.length" :href="proposalLink" class="btn btn-primary generate-proposal" target="_blank" onclick="gtag('event', 'generate_proposal');">Generate proposal</a>
                </transition>

                <transition name="fade" :duration="{ enter: 500, leave: 300 }">
                <a v-if="currentStep<nextLinks.length && currentStep>=1 && authorized && currentStep != 2" class="next-link"
                   @click="nextStep(currentStep+1)">Next: <span>{{ nextLink.title }}</span></a>
                </transition>

            </div>

        </div>

        <!-- Modals -->
        <Alert id="notlisted" titleIcon="static/img/icon-ehr-notice.svg" title="EHR NOTICE" button="Acknowledge">
            <p>You acknowledge that it is your responsibility to obtain the practice’s EHR/PMS, and verify their eligibility and integration status prior to signing them up for Tebra.</p>
        </Alert>
        <Alert id="unsure" titleIcon="static/img/icon-ehr-notice.svg" title="EHR NOTICE" button="Acknowledge">
            <p>You acknowledge that it is your responsibility to obtain the practice’s EHR/PMS, and verify their eligibility and integration status prior to signing them up for Tebra.</p>
        </Alert>
        <Alert id="none" titleIcon="static/img/icon-ehr-notice.svg" title="EHR NOTICE" button="Acknowledge">
            <p>If the practice is not currently using any EHR, they may not be eligible for Tebra. Please check with your manager to determine eligibility.</p>
        </Alert>
        <Alert id="dental-no-ehr" titleIcon="static/img/icon-ehr-notice.svg" title="EHR NOTICE" button="Acknowledge">
            <p>We are not able to integrate with this practice’s PMS; therefore this dental practice is not eligible for Tebra Foundation.</p>
        </Alert>
        <Alert id="floor" titleIcon="static/img/icon-ehr-notice.svg" title="Minimum floor required" button="Acknowledge">
            <p>Please obtain your manager’s approval for this rate prior to contract signing.</p>
        </Alert>
        <Alert id="custom" titleIcon="static/img/icon-ehr-notice.svg" title="CUSTOM PRICING" button="Acknowledge">
            <p>For practices with more than {{ maxProviders }} providers, please go through the deal desk to obtain custom pricing. Pro/Plus pricing for practices with more than {{ maxProviders }} providers is not available through this Quote Builder.</p>
        </Alert>

        <div class="modal fade overrides" id="advancedSettings" tabindex="-1" role="dialog" aria-labelledby="advancedSettings" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Advanced Settings</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>You can change the default values below.</p><br/>
                        <EditPrice :originalPrice="solutionfees.fee" name="foundationDefault" label="Foundation per provider"
                                   @focus.native="$event.target.select()" v-model="foundationDefault"
                        ></EditPrice>

                        <EditPrice :originalPrice="midlevelfees.fee" name="foundationMidlevelDefault" label="Foundation per mid-level"
                                   @focus.native="$event.target.select()" v-model="foundationMidlevelDefault"
                        ></EditPrice>

                        <EditPrice :originalPrice="firstMonthSetup" name="firstMonthDefault" label="First month setup"
                                   @focus.native="$event.target.select()" v-model="firstMonthDefault"
                        ></EditPrice>

                        <EditPrice :originalPrice="feePerAdditionalLocation" name="additionalLocationsDefault" label="Additional locations fee"
                                   @focus.native="$event.target.select()" v-model="additionalLocationsDefault"
                        ></EditPrice>

                        <v-switch v-model="toggleAnnualDiscounts" inset class="toggle" label="Automatic annual and quarterly discount"></v-switch>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveDefaults">Save defaults</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade overrides" id="overrideAnnual" tabindex="-1" role="dialog" aria-labelledby="overrideAnnual" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Annual investment</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                        <EditPrice :originalPrice="annualMonthlyFee" name="providerAnnual" label="Provider yearly rate"
                                   @focus.native="$event.target.select()" v-model="overrideAnnualProvider" :disabled="providers<1"
                        ></EditPrice>
                        <EditPrice :originalPrice="annualMidlevelFee" name="midlevelAnnual" label="Mid-level yearly rate"
                                   @focus.native="$event.target.select()" v-model="overrideAnnualMidlevel" :disabled="midlevels<1"
                        ></EditPrice>

                        <EditPrice :originalPrice="annualLocationsFee" name="locationAnnual" label="Location yearly rate"
                                   @focus.native="$event.target.select()" v-model="overrideAnnualLocations" :disabled="locations<2"
                        ></EditPrice>

                        <EditPrice :originalPrice="annualUpgradesFee" name="upgradesAnnual" label="Software upgrades yearly rate"
                                    @focus.native="$event.target.select()" v-model="overrideAnnualUpgrades" :disabled="!toggleUpgrades"
                        ></EditPrice>

                        <EditPrice :originalPrice="annualGrowthServices" name="growthServicesAnnual" label="Growth services yearly rate"
                                    @focus.native="$event.target.select()" disabled
                        ></EditPrice>

                            </div>
                        </div>
                        <div class="d-flex flex-row override-total">
                            <div class="p-2"><strong>TOTAL</strong></div>
                            <div class="p-2">{{ Math.round(( overrideAnnualProvider + overrideAnnualMidlevel + overrideAnnualLocations + overrideAnnualUpgrades + annualGrowthServices ) / 12) | toCurrency }}<span>per month</span></div>
                            <div class="p-2">=</div>
                            <div class="p-2">{{ ( overrideAnnualProvider + overrideAnnualMidlevel + overrideAnnualLocations + overrideAnnualUpgrades + annualGrowthServices ) | toCurrency }}<span>per year</span></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveAnnualOverrides">Save</button>
                    </div>
                </div>
            </div>
        </div>

    </v-app>
</template>

<script>
import solutionfeesdefault from '@/data/solutionfees.js'
import dentalpracticefees from '@/data/dentalpracticefees.js'
import midlevelfees from '@/data/midlevelfees.js'
import upgradesfees from '@/data/upgradesfees.js'
import premiumSEOItems from '@/data/premiumSEOItems.js'
import blogSocialItems from '@/data/blogSocialItems.js'
import searchAdvertisingItems from '@/data/searchAdvertisingItems.js'
import packages from '@/data/packages.js'
import specialties from '@/data/specialties'
import ehrList from '@/data/ehr'
import integrations from '@/data/integration'
import Price from '@/components/Price'
import EditPrice from '@/components/EditPrice'
import NumberField from '@/components/NumberField'
import Alert from '@/components/Alert'

export default {
  name: 'Main',
  components: {
    Price: Price,
    EditPrice: EditPrice,
    NumberField: NumberField,
    Alert: Alert
  },
  data () {
    return {
      containerId: 'SalesCalculator',

      // constants
      maxProviders: 15,
      feePerAdditionalLocation: 125,
      firstMonthSetup: 2000,
      perServicePageFee: 150,
      perFiveCustomFormsFee: 250,
      annualDiscountOneProvider: 0.9,
      annualDiscountMoreThanOneProvider: 0.85,
      quarterlyDiscount: 0.95,
      password: 'PPQuoteBuilder',

      // defaults
      foundationDefault: 0,
      foundationMidlevelDefault: 0,
      firstMonthDefault: 0,
      toggleAnnualDiscounts: true,
      additionalLocationsDefault: 0,
      overrideAnnualProvider: 0,
      overrideAnnualMidlevel: 0,
      overrideAnnualLocations: 0,
      overrideAnnualUpgrades: 0,

      // lookup tables
      specialties,
      ehrList,
      integrations,
      solutionfeesdefault,
      solutionfees: this.solutionfeesdefault,
      midlevelfees,
      upgradesfees,
      blogSocialItems,
      premiumSEOItems,
      searchAdvertisingItems,
      dentalpracticefees,
      packages,

      // updatable fields
      updatedMonthlyFee: 0,
      updatedMidlevelFee: 0,
      updatedSetupFee: 2000,
      updatedLocationsFee: 0,
      updatedServicePagesFee: 0,
      updatedCustomFormsFee: 0,
      updatedUpgradesFee: 0,
      updatedBlogSocial: 0,
      updatedPremiumSEO: 0,
      updatedSearchAdvertising: 0,
      updatedAnnualProvider: 0,
      updatedAnnualMidlevel: 0,
      updatedAnnualLocations: 0,
      updatedAnnualUpgrades: 0,
      updatedTotalAnnual: 0,

      // starting inputs
      practice: '',
      providers: 0,
      midlevels: 0,
      locations: 0,
      additionalServicePages: 0,
      additionalCustomForms: 0,
      passwordInput: '',

      // selections
      toggleUpgrades: true,
      toggleSearchAdvertising: false,
      togglePremiumSEO: false,
      toggleBlogSocial: false,
      selectedUpgrade: false,
      selectedSearchAdvertising: false,
      selectedPremiumSEO: false,
      selectedBlogSocial: false,
      selectedPackage: false,
      activeSearchAdvertisingTab: 0,
      activePremiumSEOTab: 0,
      activeBlogSocialTab: 0,
      specialty: '',
      ehr: '',
      authorized: false,
      test: 0,
      previousStep: 0,
      currentStep: 1,
      currentPanel: 1,
      tabGrowthServices: 0,
      tabUpgrades: 0,
      rate: 'monthly',
      dentalPractice: false,
      nextLinks: [
        { title: 'Your practice', id: 1 },
        { title: 'Select your package', id: 2 },
        { title: 'Your solution', id: 3 },
        { title: 'Practice mid-levels', id: 4 },
        { title: 'Software upgrades', id: 5 },
        { title: 'First month setup', id: 6 },
        { title: 'Additional locations', id: 7 },
        { title: 'Growth services', id: 8 },
        { title: 'Order summary', id: 9 }
      ],
      proposalURL: 'https://script.google.com/a/macros/tebra.com/s/AKfycbwKq3yyoCQ5BTkKnbYAEk8MEAy_OBwKYz1-EGti7exMXM9d362r_OJhI3-CbXFY8GU/exec',

      debug: false
    }
  },
  watch: {
    practiceSize () {
      if (this.practiceSize > this.maxProviders) {
        $('#custom').modal()
      }
    },
    specialty () {
      const dentalSpecialties = ['Cosmetic Dentist', 'General Dentist', 'Pediatric Dentist', 'Denturist', 'Dental Hygienist', 'Orthodontist']
      if (dentalSpecialties.includes(this.specialty)) {
        this.dentalPractice = true
        this.solutionfees = this.dentalpracticefees
        for (let i = 0; i < Object.keys(this.upgradesfees[0].floors).length; i++) {
          this.upgradesfees[0].fees[i] = 0
          this.upgradesfees[0].floors[i] = 0
          this.upgradesfees[0].annualFloors[i] = 0
        }
        if (this.selectedUpgrade === this.upgradesfees[0]) {
          this.updatedUpgradesFee = 0
        }
      } else {
        this.dentalPractice = false
        this.solutionfees = this.solutionfeesdefault
        this.selectedUpgrade = this.upgradesfees[0]
      }
    },
    ehr () {
      if (this.dentalPractice && ['notlisted', 'unsure', 'none'].includes(this.ehr.integrationType)) {
        $('#dental-no-ehr').modal()
      } else {
        if (this.ehr.integrationType === 'notlisted') $('#notlisted').modal()
        if (this.ehr.integrationType === 'unsure') $('#unsure').modal()
        if (this.ehr.integrationType === 'none') $('#none').modal()
      }
    },
    toggleUpgrades () {
      if (!this.toggleUpgrades) {
        this.selectedUpgrade = false
        this.updatedUpgradesFee = 0
      }
    },
    toggleSearchAdvertising () {
      if (!this.toggleSearchAdvertising) {
        this.selectedSearchAdvertising = false
        this.updatedSearchAdvertising = 0
      }
    },
    togglePremiumSEO () {
      if (!this.togglePremiumSEO) {
        this.selectedPremiumSEO = false
        this.updatedPremiumSEO = 0
      }
    },
    toggleBlogSocial () {
      if (!this.toggleBlogSocial) {
        this.selectedBlogSocial = false
        this.updatedBlogSocial = 0
      }
    },

    annualMonthlyFee () {
      this.updatedAnnualProvider = this.annualMonthlyFee
    },
    annualMidlevelFee () {
      this.updatedAnnualMidlevel = this.annualMidlevelFee
    },
    annualLocationsFee () {
      this.updatedAnnualLocations = this.annualLocationsFee
    },
    annualUpgradesFee () {
      this.updatedAnnualUpgrades = this.annualUpgradesFee
    },
    updatedMonthlyFee () {
      let p = this.providers
      if (this.solutionfees.floors[p]) {
        if (this.updatedMonthlyFee / this.providers < this.solutionfees.floors[p]) $('#floor').modal()
      } else {
        if (this.updatedMonthlyFee / this.providers < this.solutionfees.floors[this.maxProviders]) $('#floor').modal()
      }
    },
    updatedMidlevelFee () {
      let p = this.midlevels
      if (this.midlevelfees.floors[p]) {
        if ((this.updatedMidlevelFee / this.midlevels) < this.midlevelfees.floors[p]) $('#floor').modal()
      } else {
        if (this.updatedMidlevelFee / this.midlevels < this.midlevelfees.floors[this.maxProviders]) $('#floor').modal()
      }
    },
    updatedUpgradesFee () {
      let p = this.practiceSize
      if (this.selectedUpgrade) {
        if (this.selectedUpgrade.floors[p]) {
          if (this.updatedUpgradesFee < this.selectedUpgrade.floors[p]) $('#floor').modal()
        } else {
          if (this.updatedUpgradesFee < this.selectedUpgrade.floors[this.maxProviders]) $('#floor').modal()
        }
        if (this.dentalPractice && this.selectedUpgrade.value === 'plus') this.updatedUpgradesFee = 0
      }
    },
    selectedUpgrade () {
      if (this.selectedUpgrade) this.updatedUpgradesFee = this.selectedUpgrade.fees[this.practiceSize]
      else this.updatedUpgradesFee = 0
    },
    selectedSearchAdvertising () {
      this.updatedSearchAdvertising = 0
    },
    selectedPremiumSEO () {
      this.updatedPremiumSEO = 0
    },
    selectedBlogSocial () {
      this.updatedBlogSocial = 0
    },
    toggleAnnualDiscounts () {
      if (this.toggleAnnualDiscounts) {
        this.annualDiscountOneProvider = 0.9
        this.annualDiscountMoreThanOneProvider = 0.85
        this.quarterlyDiscount = 0.95
      } else {
        this.annualDiscountOneProvider = 1
        this.annualDiscountMoreThanOneProvider = 1
        this.quarterlyDiscount = 1
      }
    },
    overrideAnnualProvider () {
      let p = this.providers
      if (this.solutionfees.annualFloors[p]) {
        if (this.overrideAnnualProvider / this.providers < this.solutionfees.annualFloors[p]) $('#floor').modal()
      } else {
        if (this.overrideAnnualProvider / this.providers < this.solutionfees.annualFloors[this.maxProviders]) $('#floor').modal()
      }
    },
    overrideAnnualMidlevel () {
      let p = this.midlevels
      if (this.midlevelfees.annualFloors[p]) {
        if (this.overrideAnnualMidlevel / this.midlevels < this.midlevelfees.annualFloors[p]) $('#floor').modal()
      } else {
        if (this.overrideAnnualMidlevel / this.midlevels < this.midlevelfees.annualFloors[this.maxProviders]) $('#floor').modal()
      }
    },
    overrideAnnualUpgrades () {
      let p = this.practiceSize
      if (this.selectedUpgrade) {
        if (this.selectedUpgrade.annualFloors[p]) {
          if (this.overrideAnnualUpgrades < this.selectedUpgrade.annualFloors[p]) $('#floor').modal()
        } else {
          if (this.overrideAnnualUpgrades < this.selectedUpgrade.annualFloors[this.maxProviders]) $('#floor').modal()
        }
      }
    },
    totalAnnual () {
      this.updatedTotalAnnual = this.totalAnnual
    },

    selectedPackage () {
      if (this.selectedPackage) {
        this.toggleUpgrades = this.selectedPackage.toggleUpgrades
        this.toggleSearchAdvertising = this.selectedPackage.toggleSearchAdvertising
        this.togglePremiumSEO = this.selectedPackage.togglePremiumSEO
        this.toggleBlogSocial = this.selectedPackage.toggleBlogSocial
        let selectedUpgradeIndex = this.selectedPackage.selectedUpgrade
        if (selectedUpgradeIndex !== null) this.selectedUpgrade = this.upgradesfees[selectedUpgradeIndex]
        let selectedSearchAdvertisingIndex = this.selectedPackage.selectedSearchAdvertising
        if (selectedSearchAdvertisingIndex !== null) this.selectedSearchAdvertising = this.searchAdvertisingItems[selectedSearchAdvertisingIndex]
        let selectedPremiumSEOIndex = this.selectedPackage.selectedPremiumSEO
        if (selectedPremiumSEOIndex !== null) this.selectedPremiumSEO = this.premiumSEOItems[selectedPremiumSEOIndex]
        let selectedBlogSocialIndex = this.selectedPackage.selectedBlogSocial
        if (selectedBlogSocialIndex !== null) this.selectedBlogSocial = this.blogSocialItems[selectedBlogSocialIndex]

        if (this.dentalPractice && this.selectedPackage.value === 'good') {
          this.toggleUpgrades = true
          this.selectedUpgrade = this.upgradesfees[0]
        }
      }
    }
  },
  created () {
    this.setDefaults()
  },
  mounted () {
    this.authenticate()
    this.refreshNextLinks()

    let observerHack = new MutationObserver(function () {
      observerHack.disconnect()
      $('#practicename').attr('autocomplete', 'turnitoff')
    })
  },

  computed: {
    // Inputs
    practiceSize () {
      return parseInt(this.providers) + parseInt(this.midlevels)
    },
    // Software Costs
    originalMonthlyFee () {
      return this.solutionfees.fee * this.providers
    },
    updatedQuarterlyFee () {
      return (this.updatedMonthlyFee * 3 * this.quarterlyDiscount)
    },
    annualMonthlyFee () {
      return (this.providers <= 1 ? this.updatedMonthlyFee * 12 * this.annualDiscountOneProvider : this.updatedMonthlyFee * 12 * this.annualDiscountMoreThanOneProvider)
    },
    originalMidlevelFee () {
      return this.midlevelfees.fee * this.midlevels
    },
    updatedQuarterlyMidlevelFee () {
      return (this.updatedMidlevelFee * 3 * this.quarterlyDiscount)
    },
    annualMidlevelFee () {
      return (this.midlevels <= 1 ? this.updatedMidlevelFee * 12 * this.annualDiscountOneProvider : this.updatedMidlevelFee * 12 * this.annualDiscountMoreThanOneProvider)
    },
    originalLocationsFee () {
      if (this.locations > 0) return this.feePerAdditionalLocation * (this.locations - 1)
      return 0
    },
    quarterlyLocationsFee () {
      return this.updatedLocationsFee * 3
    },
    annualLocationsFee () {
      return this.updatedLocationsFee * 12
    },
    originalUpgradesFee () {
      if (this.selectedUpgrade && this.practiceSize) {
        if (this.practiceSize < this.maxProviders) {
          if (this.updatedUpgradesFee > this.selectedUpgrade.fees[this.practiceSize]) return this.updatedUpgradesFee
          return this.selectedUpgrade.fees[this.practiceSize]
        } else {
          return this.selectedUpgrade.fees[this.maxProviders]
        }
      }
      return 0
    },
    quarterlyUpgradesFee () {
      return (this.updatedUpgradesFee * 3 * this.quarterlyDiscount)
    },
    annualUpgradesFee () {
      return (this.practiceSize <= 1 ? this.updatedUpgradesFee * 12 * this.annualDiscountOneProvider : this.updatedUpgradesFee * 12 * this.annualDiscountMoreThanOneProvider)
    },
    totalMonthlySoftware () {
      return this.updatedMonthlyFee + this.updatedMidlevelFee + this.updatedLocationsFee + this.updatedUpgradesFee
    },
    updatedQuarterlySoftware () {
      return this.updatedQuarterlyFee + this.updatedQuarterlyMidlevelFee + this.quarterlyLocationsFee + this.quarterlyUpgradesFee
    },
    updatedAnnualSoftware () {
      return this.updatedAnnualProvider + this.updatedAnnualMidlevel + this.updatedAnnualLocations + this.updatedAnnualUpgrades
    },
    originalMonthlySoftware () {
      return this.originalMonthlyFee + this.originalMidlevelFee + this.originalLocationsFee + this.originalUpgradesFee
    },
    totalSoftwareSavingsMonthlyPlan () {
      return (this.originalMonthlySoftware - this.totalMonthlySoftware) * 12
    },
    totalSoftwareSavingsQuarterlyPlan () {
      return (this.originalMonthlySoftware * 12) - (this.updatedQuarterlySoftware * 4)
    },
    totalSoftwareSavingsAnnualPlan () {
      return (this.originalMonthlySoftware * 12) - this.updatedAnnualSoftware
    },

    // Onboarding Costs
    originalServicePagesFee () {
      return this.additionalServicePages * this.perServicePageFee
    },
    originalCustomFormsFee () {
      return (this.additionalCustomForms / 5) * this.perFiveCustomFormsFee
    },
    originalFirstMonthSetup () {
      return this.firstMonthSetup + this.originalServicePagesFee + this.originalCustomFormsFee
    },
    totalFirstMonthSetup () {
      return this.updatedSetupFee + this.updatedServicePagesFee + this.updatedCustomFormsFee
    },
    totalFirstMonthSavings () {
      return this.originalFirstMonthSetup - this.totalFirstMonthSetup
    },
    quarterlyFirstMonthSavings () {
      return this.originalFirstMonthSetup - this.totalFirstMonthSetup
    },
    annualFirstMonthSavings () {
      return this.originalFirstMonthSetup - this.annualFirstMonthSetup
    },
    annualFirstMonthSetup () {
      return this.totalFirstMonthSetup
    },

    // Services Costs
    originalBlogSocial () {
      if (this.updatedBlogSocial > this.selectedBlogSocial.fee) return this.updatedBlogSocial
      if (this.selectedBlogSocial) return this.selectedBlogSocial.fee
      return 0
    },
    originalPremiumSEO () {
      if (this.updatedPremiumSEO > this.selectedPremiumSEO.fee) return this.updatedPremiumSEO
      if (this.selectedPremiumSEO) return this.selectedPremiumSEO.fee
      return 0
    },
    originalSearchAdvertising () {
      if (this.updatedSearchAdvertising > this.selectedSearchAdvertising.fee) return this.updatedSearchAdvertising
      if (this.selectedSearchAdvertising) return this.selectedSearchAdvertising.fee
      return 0
    },
    originalGrowthServices () {
      return (this.toggleSearchAdvertising ? this.originalSearchAdvertising : 0) +
            (this.togglePremiumSEO ? this.originalPremiumSEO : 0) +
            (this.toggleBlogSocial ? this.originalBlogSocial : 0)
    },
    updatedGrowthServices () {
      return (this.toggleSearchAdvertising ? this.updatedSearchAdvertising : 0) +
          (this.togglePremiumSEO ? this.updatedPremiumSEO : 0) +
          (this.toggleBlogSocial ? this.updatedBlogSocial : 0)
    },
    quarterlyGrowthServices () {
      return this.updatedGrowthServices * 3
    },
    annualGrowthServices () {
      return this.updatedGrowthServices * 12
    },
    totalServicesSavings () {
      return (this.originalGrowthServices - this.updatedGrowthServices) * 12
    },

    // Overall totals
    totalMonthly () {
      return this.updatedMonthlyFee + this.updatedMidlevelFee + this.updatedLocationsFee + this.updatedUpgradesFee + this.updatedGrowthServices
    },
    totalMonthlyOriginal () {
      return this.originalMonthlyFee + this.originalMidlevelFee + this.originalLocationsFee + this.originalUpgradesFee + this.originalGrowthServices
    },
    totalMonthlySavings () {
      return (this.totalMonthlyOriginal - this.totalMonthly) * 12
    },
    totalQuarterly () {
      return this.updatedQuarterlySoftware + this.quarterlyGrowthServices
    },
    totalQuarterlyOriginal () {
      return this.totalQuarterly
    },
    totalQuarterlySavings () {
      return ((this.totalMonthlyOriginal * 3) - this.totalQuarterly) * 4
    },
    totalAnnual () {
      return this.annualMonthlyFee + this.annualMidlevelFee + this.annualLocationsFee + this.annualUpgradesFee + this.annualGrowthServices
    },
    totalAnnualSavings () {
      return (this.totalMonthlyOriginal * 12) - this.updatedTotalAnnual
    },

    // Packages
    totalPackageGoodMonthly () {
      return (this.providers * this.solutionfees.fee) + (this.midlevels * this.midlevelfees.fee) + (this.originalLocationsFee)
    },
    totalPackageBetterMonthly () {
      let upgradesFee = this.upgradesfees[0].fees[this.maxProviders]
      if (this.providers <= this.maxProviders) {
        upgradesFee = this.upgradesfees[0].fees[this.practiceSize]
      }
      if (this.dentalPractice) {
        upgradesFee = 0
      }
      return (this.providers * this.solutionfees.fee) + (this.midlevels * this.midlevelfees.fee) + (this.originalLocationsFee) + upgradesFee + this.blogSocialItems[0].fee
    },
    totalPackageBestMonthly () {
      let upgradesFee = this.upgradesfees[1].fees[this.maxProviders]
      if (this.providers <= this.maxProviders) {
        upgradesFee = this.upgradesfees[1].fees[this.practiceSize]
      }
      return (this.providers * this.solutionfees.fee) + (this.midlevels * this.midlevelfees.fee) + (this.originalLocationsFee) + upgradesFee + this.blogSocialItems[2].fee + this.premiumSEOItems[0].fee
    },

    // Misc
    monthlyOrQuarterly () {
      return (this.rate === 'monthly' || this.rate === 'quarterly')
    },
    nextLink () {
      return this.nextLinks[this.currentStep]
    },
    totalPanels () {
      return this.nextLinks.length
    },
    proposalLink () {
      let providerFee, midlevelFee, locationsFee, upgradesFee, softwareSavings, softwareTotal, searchAdvertisingFee, premiumSEOFee, blogSocialFee, servicesTotal, setupFee, firstMonthSavings, firstMonthTotal, total, totalSavings, rateBreakdown, rateInvestment
      if (this.rate === 'monthly') {
        providerFee = this.updatedMonthlyFee ? this.updatedMonthlyFee : ''
        midlevelFee = this.updatedMidlevelFee ? this.updatedMidlevelFee : ''
        locationsFee = this.locations > 1 ? this.updatedLocationsFee : ''
        upgradesFee = this.toggleUpgrades && this.selectedUpgrade ? this.updatedUpgradesFee : ''
        softwareSavings = this.totalSoftwareSavingsMonthlyPlan ? this.totalSoftwareSavingsMonthlyPlan : ''
        softwareTotal = this.totalMonthlySoftware ? this.totalMonthlySoftware : ''
        searchAdvertisingFee = this.toggleSearchAdvertising && this.updatedSearchAdvertising ? this.toCurrency(this.updatedSearchAdvertising) : ''
        premiumSEOFee = this.togglePremiumSEO && this.selectedPremiumSEO ? this.toCurrency(this.updatedPremiumSEO) : ''
        blogSocialFee = this.toggleBlogSocial && this.selectedBlogSocial ? this.toCurrency(this.updatedBlogSocial) : ''
        servicesTotal = this.updatedGrowthServices ? this.toCurrency(this.updatedGrowthServices) : ''
        setupFee = this.updatedSetupFee
        firstMonthSavings = this.totalFirstMonthSavings
        firstMonthTotal = this.totalFirstMonthSetup
        totalSavings = this.totalMonthlySavings
        total = this.totalMonthly
        rateBreakdown = 'per month'
        rateInvestment = 'per month'
      } else if (this.rate === 'quarterly') {
        providerFee = this.updatedQuarterlyFee ? this.updatedQuarterlyFee : ''
        midlevelFee = this.updatedQuarterlyMidlevelFee ? this.updatedQuarterlyMidlevelFee : ''
        locationsFee = this.locations > 1 ? this.quarterlyLocationsFee : ''
        upgradesFee = this.toggleUpgrades && this.selectedUpgrade ? this.quarterlyUpgradesFee : ''
        softwareSavings = this.totalSoftwareSavingsQuarterlyPlan ? this.totalSoftwareSavingsQuarterlyPlan : ''
        softwareTotal = this.updatedQuarterlySoftware ? this.updatedQuarterlySoftware : ''
        searchAdvertisingFee = this.toggleSearchAdvertising && this.updatedSearchAdvertising ? this.toCurrency(this.updatedSearchAdvertising) : ''
        premiumSEOFee = this.togglePremiumSEO && this.selectedPremiumSEO ? this.toCurrency(this.updatedPremiumSEO) : ''
        blogSocialFee = this.toggleBlogSocial && this.selectedBlogSocial ? this.toCurrency(this.updatedBlogSocial) : ''
        servicesTotal = this.updatedGrowthServices ? this.toCurrency(this.updatedGrowthServices) : ''
        setupFee = this.updatedSetupFee
        firstMonthSavings = this.quarterlyFirstMonthSavings
        firstMonthTotal = this.totalFirstMonthSetup
        totalSavings = this.totalQuarterlySavings
        total = this.totalQuarterly
        rateBreakdown = 'per quarter'
        rateInvestment = 'per quarter'
      } else {
        providerFee = this.updatedAnnualProvider ? this.updatedAnnualProvider : ''
        midlevelFee = this.updatedAnnualMidlevel ? this.updatedAnnualMidlevel : ''
        locationsFee = this.locations > 1 ? this.updatedAnnualLocations : ''
        upgradesFee = this.toggleUpgrades && this.selectedUpgrade ? this.updatedAnnualUpgrades : ''
        softwareSavings = this.totalSoftwareSavingsAnnualPlan ? this.totalSoftwareSavingsAnnualPlan : ''
        softwareTotal = this.updatedAnnualSoftware ? this.updatedAnnualSoftware : ''
        searchAdvertisingFee = this.toggleSearchAdvertising && this.updatedSearchAdvertising ? this.toCurrency(this.updatedSearchAdvertising * 12) : ''
        premiumSEOFee = this.togglePremiumSEO && this.selectedPremiumSEO ? this.toCurrency(this.updatedPremiumSEO * 12) : ''
        blogSocialFee = this.toggleBlogSocial && this.selectedBlogSocial ? this.toCurrency(this.updatedBlogSocial * 12) : ''
        servicesTotal = this.updatedGrowthServices ? this.toCurrency(this.updatedGrowthServices * 12) : ''
        setupFee = 0
        firstMonthSavings = this.annualFirstMonthSavings
        firstMonthTotal = this.annualFirstMonthSetup
        totalSavings = this.totalAnnualSavings
        total = this.updatedTotalAnnual
        rateBreakdown = 'per year'
        rateInvestment = 'per year'
      }

      let proposalValues = {
        practiceName: this.practice,
        providers: this.providers,
        midlevels: this.midlevels,
        locations: this.locations,
        ehr: this.integrations[this.ehr.integrationType] ? this.ehr.name : 'N/A',
        integrationType: this.integrations[this.ehr.integrationType] ? this.integrations[this.ehr.integrationType].name : '',
        integrationDesc: this.integrations[this.ehr.integrationType] ? this.integrations[this.ehr.integrationType].description : '',
        providerType: this.solutionfees ? this.solutionfees.fullname : '',
        midlevelType: this.midlevels > 0 && this.midlevelfees ? this.midlevelfees.fullname : '',
        providerFee: this.toCurrency(providerFee),
        midlevelFee: this.toCurrency(midlevelFee),
        locationsFee: this.toCurrency(locationsFee),
        upgradesType: this.selectedUpgrade ? this.selectedUpgrade.fullname : '',
        upgradesFee: this.toCurrency(upgradesFee),
        softwareSavings: this.toCurrency(softwareSavings),
        softwareTotal: this.toCurrency(softwareTotal),
        rate: rateBreakdown,
        rateInvestment: rateInvestment,
        searchAdvertising: this.toggleSearchAdvertising && this.selectedSearchAdvertising ? this.selectedSearchAdvertising.fullname : '',
        searchAdvertisingFee: searchAdvertisingFee,
        premiumSEO: this.togglePremiumSEO && this.selectedPremiumSEO ? this.selectedPremiumSEO.fullname : '',
        premiumSEOFee: premiumSEOFee,
        blogSocial: this.toggleBlogSocial && this.selectedBlogSocial ? this.selectedBlogSocial.fullname : '',
        blogSocialFee: blogSocialFee,
        servicesSavings: this.totalServicesSavings ? this.toCurrency(this.totalServicesSavings) : '',
        servicesTotal: servicesTotal,
        setupFee: this.toCurrency(setupFee),
        additionalPages: this.additionalServicePages ? this.additionalServicePages : '',
        additionalPagesFee: this.updatedServicePagesFee ? this.toCurrency(this.updatedServicePagesFee) : '$0',
        customForms: this.additionalCustomForms ? this.additionalCustomForms : '',
        customFormsFee: this.updatedCustomFormsFee ? this.toCurrency(this.updatedCustomFormsFee) : '$0',
        firstMonthSavings: this.toCurrency(firstMonthSavings),
        firstMonthTotal: this.toCurrency(firstMonthTotal),
        total: this.toCurrency(total),
        totalSavings: this.toCurrency(totalSavings),
        test: this.test
      }

      return this.proposalURL + '?' + $.param(proposalValues, true)
    }

  },

  methods: {
    authenticate () {
      if (window.location.hostname === 'localhost' || (this.$route.query.letmein)) {
        this.authorized = true
        this.test = 1
        return
      }

      if (this.$cookies && this.$cookies.isKey('ppqb')) {
        this.authorized = true
        return
      }
      let offset = -8
      let currentDate = new Date(new Date().getTime() + offset * 3600 * 1000)
      let date = currentDate.toJSON().slice(0, 10).replace(/-/g, '')
      let string = this.password + date
      let hash = this.generateHash(string)
      if (this.$route && this.$route.query.token) {
        let token = this.$route.query.token
        if (hash.toString() === token) {
          this.authorized = true
          this.$cookies.set('ppqb', hash, '7d')
        }
      }
    },
    generateHash (string) {
      let hash = 0
      for (let i = 0; i < string.length; i++) {
        let char = string.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash = hash & hash
      }
      return hash
    },
    activeStep (step) {
      if (this.currentStep === step) return 'active'
    },
    activePanel (panelId) {
      if (this.authorized) {
        let currentIndex = this.currentStep - 1
        let currentPanel = this.nextLinks[currentIndex]
        if (currentPanel.id && currentPanel.id === panelId.toString()) return 'active'
      }
    },
    customFilter (item, queryText, itemText) {
      const textOne = item.display.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    getAddressData (addressData, placeResultData, id) {
      this.practice = addressData.name
    },
    setPracticeInput (object) {
      this.practice = object.name
    },
    nextStep (step) {
      this.refreshNextLinks()
      this.previousStep = this.currentStep
      this.currentStep = step
      if (this.nextLinks[step]) this.currentPanel = this.nextLinks[step].id
    },
    lastStep () {
      this.refreshNextLinks()
      this.previousStep = this.currentStep
      this.currentStep = this.nextLinks.length
      this.currentPanel = this.nextLinks.at(-1).id
    },
    refreshNextLinks () {
      let panels = document.getElementsByClassName('panel-step')
      if (!panels.length) {
        return
      }
      this.nextLinks = []
      for (let obj of panels) {
        if (obj.style.display !== 'none' && obj.style.display === '') {
          this.nextLinks.push({ title: obj.dataset.title, id: obj.dataset.id })
        }
      }
    },
    toCurrency (value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    selectPackage (packageId) {
      this.selectedPackage = packages[packageId]
    },
    saveAnnualOverrides () {
      this.updatedAnnualProvider = this.overrideAnnualProvider
      this.updatedAnnualMidlevel = this.overrideAnnualMidlevel
      this.updatedAnnualLocations = 1
      this.updatedAnnualLocations = this.overrideAnnualLocations
      this.updatedAnnualUpgrades = this.overrideAnnualUpgrades
      this.updatedTotalAnnual = this.updatedAnnualProvider + this.updatedAnnualMidlevel + this.updatedAnnualLocations + this.overrideAnnualUpgrades + this.annualGrowthServices
    },
    setDefaults () {
      this.selectedPackage = this.packages[1]
      this.solutionfees = this.solutionfeesdefault
      this.foundationDefault = this.solutionfees.fee
      this.foundationMidlevelDefault = this.midlevelfees.fee
      this.firstMonthDefault = this.firstMonthSetup
      this.additionalLocationsDefault = this.feePerAdditionalLocation
      this.toggleAnnualDiscounts = true
    },
    saveDefaults () {
      this.solutionfees.fee = this.foundationDefault
      this.midlevelfees.fee = this.foundationMidlevelDefault
      this.firstMonthSetup = this.firstMonthDefault
      this.feePerAdditionalLocation = this.additionalLocationsDefault
      if (this.toggleAnnualDiscounts) {
        this.annualDiscountOneProvider = 0.9
        this.annualDiscountMoreThanOneProvider = 0.85
      } else {
        this.annualDiscountOneProvider = 1
        this.annualDiscountMoreThanOneProvider = 1
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../node_modules/vuetify/dist/vuetify.min.css';
    @import '../styles/variables';
    @import '../styles/typography';
    @import '../styles/layout';
    @import '../styles/autocomplete';
    @import '../styles/packages';

    .specialty.v-text-field--enclosed .v-input__append-inner {
        display: none;
    }
    .specialties {
        position: relative;
        top: -57px;
    }

    .ehr.v-text-field--enclosed .v-input__append-inner {
        display: none;
    }
    .ehrList {
        position: relative;
        top: -57px;
    }

    .content-tabs {
            .v-tab {
                text-transform: none;
                letter-spacing: -0.03em;
                font-family: $head-semi-bold-font-family;
                font-weight: normal;
                font-size: 0.875em;
                color: $text-20;
                padding: 0;
                text-transform: uppercase;
                border-bottom: 1px solid $core;
                &.v-tab--active {
                    border-bottom: 3px solid $growth;

                }
            }
    }
    .theme--light.v-tabs-items {
        background-color: transparent;
    }

    .v-list-item {
        display: flex;
        justify-content: space-between;
        span {
            flex: 0 1 auto;
            display: inline;
        }
        .option--cost {
            color: $text-20;
            font-size: 0.8em;
            text-align: right;
            flex: 1 1 auto;
        }
    }

    .v-tabs--vertical>.v-tabs-bar .v-tab {
        justify-content: left;
        font-size: 0.75em;
        padding: 0 10px;
    }

    .v-application .btn-primary {
        background: $growth;
        border-color: $growth;
        color: white;
    }

    .v-messages * {
        font-size: 10px;
    }
    .modal .v-messages * {
        font-size: 9px;
    }

    .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
        color: #DDDFE8;
    }
    .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)>.v-input__control>.v-input__slot:hover fieldset {
        color: #BBBFD6;
    }
    .theme--light.v-label {
        color: #697492;
    }
    .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
        color: #697492;
        &::placeholder {
            color: #697492;
        }
    }

    .v-input--selection-controls .v-radio>.v-label {
        margin-bottom: 0;
        font-size: 1.125em;
    }
    .v-input--radio-group.v-input--radio-group--row .v-radio {
        vertical-align: bottom;
    }
    .modal-header {
        padding: 55px 55px 20px 55px;
        border-bottom: 0;
        .modal-title {
            font-size: 1.375em;
            font-family: $head-semi-bold-font-family;
            color: $text-60;
        }
        #advancedSettings & {
            padding-bottom: 0;
        }
        .close {
            font-size: 30px;
            margin: -3rem -3rem -1rem auto;
            span {
                font-size: 30px;
            }
        }
    }
    .modal-body {
        padding: 0 55px;
        p {
            margin-bottom: 10px;
            font-size: 1em;
            font-family: $body-font-family;
        }
    }
    .modal-footer {
        padding: 20px 55px 55px 55px;
        border-top: 0;
        justify-content: flex-end;
    }

    .savings-text {
        display: inline-block;
        color: $primary;
        font-family: $head-semi-bold-font-family;
        font-size: 1.5em;
        margin-right: 15px;
        letter-spacing: -0.03em;
        span {
            font-size: 1.25em;
            color: $primary;
        }
    }

    .vertical-tabs-selector {
        margin: 40px auto;
        letter-spacing: 0.5px;
        position: relative;
        list-style: none;
        text-align: left;
        font-weight: 100;
        max-width: 30%;

        .tab-selector {
            background: none;
            margin: 0;
            padding-top: 0;
            padding-bottom: 40px;
            padding-left: 25px;
            line-height: 10px;
            position: relative;
            border-left: 3px solid $care;
            border-bottom-right-radius: 4px;
            border-top-right-radius: 4px;
            text-transform: uppercase;
            font-family: $head-semi-bold-font-family;
            font-size: 12px;

            &:last-of-type {
                padding-bottom: 0;
                margin-bottom: 0;
                border-color:transparent;
            }

            &:before, &:after {
                position: absolute;
                display: block;
                top: 0;
                content: '';
            }

            &:after {
                box-shadow: 0 0 0 3px $care;
                background: $care;
                left: -8px;
                border-radius: 50%;
                height: 11px;
                width: 11px;
                content: "";
                top: 0;
            }
            &.active {
                color: $growth;
                &:after {
                    box-shadow: 0 0 0 3px $growth-3;
                    background: $growth-3;
                }
            }
            &:hover {
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue